import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

export default class IndividualAddressController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
}
